import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable} from 'mobx'

export default class Club extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      id: observable,
      name: observable,
      logo: observable,
      owner: observable,
      about: observable,
      phone_number: observable,
      whatsapp: observable,
      instagram: observable,
      country_id: observable,
      country: observable,
      region: observable,
      region_id: observable,
      district: observable,
      district_id: observable,
      address: observable,
      sports: observable,
      sport_names: observable,
      location: observable,
      data: observable,
      status: observable,
      is_valid: computed,
      parent: observable,
      children: observable,
      roles: observable,
      relatives: observable,
      is_manager: computed,
      is_branch_manager: computed,
      is_trainer: computed,
      is_parent: computed,
      is_member: computed,
      locations: observable,
      trainers: observable,
      game_teams: observable,
      game_team_details: observable
    })
  }
  
  id = 0;
  name = '';
  owner = {};
  address = '';
  about = '';
  phone_number = '';
  whatsapp = '';
  instagram = '';
  country_id = null;
  country = {};
  region_id = null;
  region = {};
  district_id = null;
  district = {};
  sports = [];
  sport_names = [];
  location = null;
  data = {};
  status = 'active';
  parent = null;
  children = [];
  roles = [];
  relatives = [];
  locations = [];
  trainers = [];
  logo = 'https://placehold.co/200?text=No+Photo&font=roboto';
  game_teams = [];
  game_team_details = {}
  
  get is_valid() {
    return this.name && this.owner_phone && this.address && this.sports.length > 0 && this.location;
  }
  
  get is_manager() {
    return this.roles.some(role => role.id === 'OWN' || role.id ==='MGR')
  }

  get is_branch_manager() {
    return this.children.length > 0 && this.children.some(child => child.roles.some(role => role.id === 'OWN' || role.id ==='MGR'))
  }
  
  get is_trainer() {
    return this.roles.some(role => role.id === 'TRN');
  }

  get is_branch_trainer() {
    return this.children.length > 0 && this.children.some(child => child.roles.some(role => role.id === 'TRN'))
  }
  
  get is_parent() {
    return this.roles.some(role => role.id ==='PRNT');
  }
  
  get is_member() {
    return this.roles.some(role => role.id ==='MMBR');
  }
}